import axios from 'axios'
import { ChannelFormDto } from '../../../../_metronic/partials/widgets/ChannelForm'
import * as authHelper from '../../auth/core/AuthHelpers'
import { string } from 'yup'
import { IInformationPreferences, informationPreferences } from '../../accounts/components/settings/SettingsModel'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/authanticate/verify_token`
export const LOGIN_URL = `${API_URL}/authanticate/login`
export const REGISTER_URL = `${API_URL}/authanticate/Signup`
export const REQUEST_PASSWORD_URL = `${API_URL}/authanticate/SendForgotPasswordEmail`
export const CheckAndRefreshTokenUrl = `${API_URL}/authanticate/CheckAndRefreshToken`
export const UpdateLanguageUrl = `${API_URL}/settings/UpdateLanguage`
export const ActivateAccountUrl = `${API_URL}/authanticate/ActivateAccount`
export const ActivateTeamMemberAccountUrl = `${API_URL}/authanticate/ActivateTeamMemberAccount`
export const FreezeAccountUrl = `${API_URL}/settings/FreezeAccount`
export const FreezeCompanyUrl = `${API_URL}/settings/FreezeCompany`
export const ResetPasswordUrl = `${API_URL}/authanticate/ResetPassword`
export const UpdatePasswordUrl = `${API_URL}/settings/UpdatePassword`
export const UpdateProfileUrl = `${API_URL}/settings/UpdateProfile`
export const UpdateProfileInformationPreferencesUrl = `${API_URL}/settings/UpdateProfileInformationPreferences`
export const GetProfileInformationPreferencesUrl = `${API_URL}/settings/GetProfileInformationPreferences`
export const UpdateCompanyUrl = `${API_URL}/settings/UpdateCompanyDetails`
export const AddOrUpdateChannelUrl = `${API_URL}/settings/AddOrUpdateChannel`
export const DeleteChannelUrl = `${API_URL}/settings/DeleteChannel`
export const GetChannelListUrl = `${API_URL}/settings/GetChannelList`

export function login(email: string, password: string, isRememberMeChecked: boolean, deviceInfo: any) {

  let deviceInfoParsed = deviceInfo != null ? JSON.parse(deviceInfo) : null;
  let data = {
    'email': email,
    'password': password,
    'isRememberMeChecked': isRememberMeChecked,
    deviceInfo: deviceInfoParsed == null ? null : {
      ntoken: deviceInfoParsed?.ntoken,
      name: deviceInfoParsed?.name,
      type: deviceInfoParsed?.type,
      model: deviceInfoParsed?.model,
      brand: deviceInfoParsed?.brand,
      systemName: deviceInfoParsed?.systemName,
      systemVersion: deviceInfoParsed?.systemVersion
    }
  }
  // alert(JSON.stringify(data))

  return axios({
    method: 'post',
    url: LOGIN_URL,
    // url: 'https://api.aisenseus.net/api/Authanticate/Login',
    data: data
  });
}

export function updateProfile(nameSurname: string, language: string, timeZoneValue: string, timeZoneText: string, imageData: string) {

  return axios({
    method: 'post',
    url: UpdateProfileUrl,
    data: {
      'nameSurname': nameSurname,
      'timeZoneValue': timeZoneValue,
      'timeZoneText': "GMT" + timeZoneText,
      'language': language,
      'imageData': imageData,
    }
  });
}

export function getProfileInformationPreferences(): Promise<IInformationPreferences | undefined> {
  return axios
    .get(GetProfileInformationPreferencesUrl).then(response => {
      var responseParsed: IInformationPreferences = {
        insights: { email: response.data.result.insights_Email as boolean, notification: response.data.result.insights_Notification as boolean, },
        newInvoices: { email: response.data.result.newInvoices_Email as boolean, notification: response.data.result.newInvoices_Notification as boolean, },
        newsletters: { email: response.data.result.newsletters_Email as boolean, notification: response.data.result.newsletters_Notification as boolean, },
        blogs: { email: response.data.result.blogs_Email as boolean, notification: response.data.result.blogs_Notification as boolean, },
        campaigns: { email: response.data.result.campaigns_Email as boolean, notification: response.data.result.campaigns_Notification as boolean, },
        usageAlerts: { email: response.data.result.usageAlerts_Email as boolean, notification: response.data.result.usageAlerts_Notification as boolean, },
      };
      return responseParsed;
    });
}

export function updateProfileInformationPreferences(
  insights_Email: boolean, insights_Notification: boolean,
  newInvoices_Email: boolean, newInvoices_Notification: boolean,
  newsletters_Email: boolean, newsletters_Notification: boolean,
  blogs_Email: boolean, blogs_Notification: boolean,
  campaigns_Email: boolean, campaigns_Notification: boolean,
  usageAlerts_Email: boolean, usageAlerts_Notification: boolean,
) {

  return axios({
    method: 'post',
    url: UpdateProfileInformationPreferencesUrl,
    data: {
      insights_Email, insights_Notification,
      newInvoices_Email, newInvoices_Notification,
      newsletters_Email, newsletters_Notification,
      blogs_Email, blogs_Notification,
      campaigns_Email, campaigns_Notification,
      usageAlerts_Email, usageAlerts_Notification,
    }
  });
}

export function updateCompany(companyName: string, language: string, timeZoneValue: string, timeZoneText: string, country: string, website: string, phone: string, membershipType: number, imageData: string) {

  return axios({
    method: 'post',
    url: UpdateCompanyUrl,
    data: {
      'companyName': companyName,
      'language': language,
      'timeZoneValue': timeZoneValue,
      'timeZoneText': "GMT" + timeZoneText,
      'phone': phone,
      'website': website,
      'country': country,
      'membershipType': membershipType,
      'imageData': imageData,
    }
  });
}

export function GetChannelList() {
  const auth = authHelper.getAuth()
  // console.log('auth', auth)
  return axios({
    method: 'get',
    url: GetChannelListUrl,
    headers: {
      Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
    },
  }).then(response => {
    var responseParsedList = [new ChannelFormDto]
    responseParsedList[0].id = "";
    responseParsedList.shift();
    if (response.data.result.length !== 0) {
      response.data.result.forEach((element: any) => {
        if (element !== undefined) {
          var queryArray: object[] = []
          // console.log(element.querySynonyms)
          if (element.querySynonyms !== undefined && element.querySynonyms !== null) {
            for (let i = 0; i < element.querySynonyms.length; i++) {
              queryArray.push({ "label": String(element.querySynonyms[i]), "value": String(element.querySynonyms[i]) })
            }
          }
          var queryExceptionArray: object[] = []
          if (element.queryExceptions !== undefined && element.queryExceptions !== null) {
            for (let i = 0; i < element.queryExceptions.length; i++) {
              queryExceptionArray.push({ "label": String(element.queryExceptions[i]), "value": String(element.queryExceptions[i]) })
            }
          }
          var responseParsed: ChannelFormDto = {
            channelName: element.name,
            companyId: element.companyId,
            id: element.id,
            searchQuery: element.query,
            searchQueryList: queryArray,
            searchQueryExceptionList: queryExceptionArray,
            searchUrl: element.searchUrl,
            type: element.channelType,
            isAutoSearch: element.isAutoSearch,
            expirationTime: element.expirationTime,
            token: element.token,
            tokenExpirationDate: element.tokenExpirationDate,
            isCompetitor: element.isCompetitor,
            competitorName: element.competitorName
          }
          responseParsedList.push(responseParsed)
        }
      });
    }
    return responseParsedList
  });
}

export function addOrUpdateChannel(Id: string, Name: string, CompanyId: string, Query: string, type: number, searchUrl: string, isAutoSearch: boolean, querySynonyms: string[], queryExceptions: string[], expirationTime: string, isCompetitor: boolean, competitorName: string) {

  return axios({
    method: 'post',
    url: AddOrUpdateChannelUrl,
    data: {
      'Id': Id,
      'Name': Name,
      'Query': Query,
      'CompanyId': CompanyId,
      'ChannelType': type,
      'IsAutoSearch': isAutoSearch,
      "QuerySynonyms": querySynonyms,
      "QueryExceptions": queryExceptions,
      'SearchUrl': searchUrl,
      'ExpirationTime': expirationTime,
      'IsCompetitor': isCompetitor,
      'CompetitorName': competitorName
    }
  });
}

export function deleteChannel(Id: string) {
  return axios({
    method: 'post',
    url: DeleteChannelUrl,
    data: {
      'Id': Id,
    }
  });
}

export function checkAndRefreshToken(token: string) {
  return axios({
    method: 'post',
    url: CheckAndRefreshTokenUrl,
    data: {
      'token': token
    }
  }).catch(function (error) {

  })
}

export function updateLanguage(language: string, reload = false) {

  axios({
    method: 'post',
    url: UpdateLanguageUrl,
    data: {
      'language': language
    }
  }).then(response => {
    if (reload === true)
      window.location.reload();
  })
}


// Server should return AuthModel
export function register(
  NameSurname: string,
  Email: string,
  Password: string,
  ConfirmPassword: string,
  CompanyName: string,
  Language: string
) {
  var offset = new Date().getTimezoneOffset();
  const timezone = offset / -60
  console.log(timezone);
  if (Language === undefined || Language === null || Language === "") { Language = navigator.language; }

  return axios.post(REGISTER_URL, {
    NameSurname: NameSurname,
    Email,
    Password,
    Confirm: ConfirmPassword,
    CompanyName,
    Timezone: timezone,
    Language
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios({
    method: 'post',
    url: REQUEST_PASSWORD_URL,
    data: {
      'email': email
    }
  });
}

export function resetPassword(c: string, password: string, confirmPassword: string) {
  return axios({
    method: 'post',
    url: ResetPasswordUrl,
    data: {
      'Password': password,
      'Code': c,
      'Confirm': confirmPassword
    }
  });
}

export function resetPasswordinProfile(password: string, newPassword: string) {
  return axios({
    method: 'post',
    url: UpdatePasswordUrl,
    data: {
      'OldPassword': password,
      'NewPassword': newPassword,
    }
  });
}

export function activateAccount(c: string) {
  return axios({
    method: 'post',
    url: ActivateAccountUrl,
    data: {
      'code': c
    }
  });
}

// Server should return AuthModel
export function activateTeamMemberAccount(
  Code: string,
  NameSurname: string,
  Email: string,
  Password: string,
  ConfirmPassword: string,
  AcceptTerms: boolean,
) {
  var offset = new Date().getTimezoneOffset();
  const timezone = offset / -60
  var userLang = navigator.language;
  return axios.post(ActivateTeamMemberAccountUrl, {
    Code,
    NameSurname,
    Email,
    Password,
    Confirm: ConfirmPassword,
    IsAggree: AcceptTerms,
    Timezone: timezone,
    Language: userLang
  })
}

export function freezeAccount(Password: string, ConfirmPassword: string) {
  return axios.post(FreezeAccountUrl, {
    Password,
    Confirm: ConfirmPassword,
  })
}

export function freezeCompany(Password: string, ConfirmPassword: string) {
  return axios.post(FreezeCompanyUrl, {
    Password,
    Confirm: ConfirmPassword,
  })
}